export const utils = {

  // Copy input value to clipboard
  async copyToClipboard(inputRef) {
    const input = this.$refs[inputRef];

    if (!input) return;

    input.select();

    try {
      await navigator.clipboard.writeText(input.value);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
};